import { AuthProvider, useAuth } from './AuthContext';
import { Login } from './Login';
import { Admin } from './Admin';

function Shell() {
  const { user, hydrating } = useAuth();
  if (hydrating) return null;
  return user ? <Admin /> : <Login />;
}

export function App() {
  return (
    <AuthProvider>
      <Shell />
    </AuthProvider>
  );
}
